import { normalizePhoneNumber } from './number.utils'

export type ContactField = 'phone' | 'mobile' | 'email' | 'fax'

export function getContactHref(field: ContactField, value: string): string {
  switch (field) {
    case 'phone':
    case 'mobile':
      return `tel:${normalizePhoneNumber(value) ?? value}`
    case 'email':
      return `mailto:${value}`
    case 'fax': {
      const normalized = normalizePhoneNumber(value)
      return normalized ? `mailto:${normalized}@faxmaker.com` : `mailto:${value}`
    }
  }
}
